import React from 'react';
import LatestArticleMediaBlock from './LatestArticleMediaBlock';
import { HeadingFour, Container, Col } from 'hui';
import Constants from '../../../constants/Articles';
import ImageCarousel from '../../../organisms/HowHipagesWorks/ImageCarousel';

type Props = {
  articles: { title: string; hero: string; key: string }[];
  topicName: string;
  topicKey: string;
  topicCategory?: string;
};

const LastestArticles: React.FC<Props> = ({ articles, topicName, topicKey, topicCategory }) => {
  // We only want to show the topic name if it is related to a category
  return (
    <Container>
      <HeadingFour as={topicKey ? `a` : `p`} href={topicKey ? `/c/${topicKey}` : false}>
        {topicName && topicCategory
          ? `Latest ${topicName.toLowerCase()} articles`
          : `Latest articles`}
      </HeadingFour>
      <ImageCarousel showDots autoplayMs={5000} infinite>
        {articles.length > 0 &&
          articles
            .slice(0, Constants.LATEST_ARTICLE_MAX_DISPLAY_AMOUNT)
            .map(({ title, hero, key }, index, array) => {
              if (index % 2 === 0) {
                const hasNextItem = !!array[index + 1];
                const nextItem = hasNextItem ? array[index + 1] : null;
                return (
                  <Col xs={6} md={3} key={key} mb={{ xs: 1.5, md: 1 }}>
                    <LatestArticleMediaBlock name={title} hero={hero} articleKey={key} />
                    {hasNextItem && (
                      <LatestArticleMediaBlock
                        name={nextItem.title}
                        hero={nextItem.hero}
                        articleKey={nextItem.key}
                      />
                    )}
                  </Col>
                );
              }
            })
            .filter(Boolean)}
      </ImageCarousel>
    </Container>
  );
};

export default LastestArticles;
